import { PanelContainer } from '../../common/panel/PanelContainer'
import Layout from '../common/Layout'
import { Period } from '../common/period'
import { SummaryHighlight } from '../common/summaryHighlight'
import { Alerts } from './alerts'
import { HeaderContent } from './headerContent'
import { PortfolioOverview } from './portfolioOverview'
import { PortfolioSegmentation } from './portfolioSegmentation'
import { ScoreDistribution } from './scoreDistribution'
import { TopHighest } from './topHighest'

const PortfolioSummary = () => {
  const renderCustomHeader = () => {
    return <HeaderContent />
  }

  const renderLeftBar = () => {
    return <Period />
  }

  const renderBottom = () => {
    return (
      <>
        <SummaryHighlight />

        <PanelContainer>
          <PortfolioOverview />
          <ScoreDistribution />
          <Alerts />
          <PortfolioSegmentation />
          <TopHighest />
        </PanelContainer>
      </>
    )
  }

  return (
    <Layout
      hasCurrencyUnit
      renderCustomHeader={renderCustomHeader}
      renderLeftBar={renderLeftBar}
      renderBottom={renderBottom}
    />
  )
}

export default PortfolioSummary
